export default __webpack_public_path__ + "static/media/Wed me good.95be838e.webp";